import { render, staticRenderFns } from "./ModerateContent.vue?vue&type=template&id=7a1dfdc0&scoped=true&"
import script from "./ModerateContent.vue?vue&type=script&lang=js&"
export * from "./ModerateContent.vue?vue&type=script&lang=js&"
import style0 from "./ModerateContent.vue?vue&type=style&index=0&id=7a1dfdc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a1dfdc0",
  null
  
)

export default component.exports